export enum UserRoleSelectionEnum {
  Agent,
  Evaluator,
  User,
}
